(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["two-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('two-button-video-block')) {
    class TwoButtonVideoBlock extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';

        this.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-video-trigger]');

          if (trigger && this.contains(trigger)) {
            const modalId = trigger.getAttribute('aria-controls');
            const dialog = document.getElementById(modalId);

            if (dialog) {
              this.openVideo(dialog);
            }

            return;
          }

          const closeButton = event.target.closest('[data-video-close]');

          if (closeButton && this.contains(closeButton)) {
            const dialog = closeButton.closest('dialog');

            if (dialog) {
              dialog.close();
            }
          }
        });

        this.querySelectorAll('.two-button-video-block__modal').forEach((dialog) => {
          /*
           * Clicking the backdrop closes the modal.
           */
          dialog.addEventListener('click', (event) => {
            if (event.target === dialog) {
              dialog.close();
            }
          });

          /*
           * Escape also fires the dialog's native close event,
           * so all video cleanup can happen here.
           */
          dialog.addEventListener('close', () => {
            this.stopVideo(dialog);
          });
        });
      }

      openVideo(dialog) {
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }

        const iframe = dialog.querySelector('[data-video-iframe]');

        if (iframe && !iframe.getAttribute('src')) {
          iframe.setAttribute('src', iframe.dataset.src);
        }

        const video = dialog.querySelector('video');

        if (video) {
          const playPromise = video.play();

          if (playPromise !== undefined) {
            playPromise.catch(() => {
              /*
               * Some browsers may block autoplay with audio.
               * The native controls remain available in that case.
               */
            });
          }
        }
      }

      stopVideo(dialog) {
        const iframe = dialog.querySelector('[data-video-iframe]');

        /*
         * Removing the iframe source completely stops
         * YouTube/Vimeo playback.
         */
        if (iframe) {
          iframe.removeAttribute('src');
        }

        const video = dialog.querySelector('video');

        if (video) {
          video.pause();

          try {
            video.currentTime = 0;
          } catch (error) {
            // Video metadata may not have loaded yet.
          }
        }
      }
    }

    customElements.define(
      'two-button-video-block',
      TwoButtonVideoBlock
    );
  }
  } catch(e) { console.error(e); }
})();

})();
